<template>
    <div class="templete">
        <div class="search_box clearfix StockSearch">
            <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="捆包号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.breed" multiple collapse-tags placeholder="品名" @visible-change="getSelectWarehouseList('breed')">
                <el-option v-for="list in selectMapC.breed" :key="list.id" :value="list.name" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.brand" multiple collapse-tags placeholder="品牌" @visible-change="getSelectWarehouseList('brand')">
                <el-option v-for="list in selectMapC.brand" :key="list.id" :value="list.name" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.grade" multiple collapse-tags placeholder="等级" @visible-change="getSelectWarehouseList('grade')">
                <el-option v-for="list in selectMapC.grade" :key="list.id" :value="list.name" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectWarehouseList('sales_thickness')">
                <el-option v-for="(list,index) in selectMapC.sales_thickness" :key="index" :value="list.name" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('sales_length')">
                <el-option v-for="(list,index) in selectMapC.sales_length" :key="index" :value="list.name" :label="list.name"></el-option>
            </el-select>

            <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.warehouse" multiple collapse-tags placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse')">
                <el-option v-for="list in selectMapC.warehouse" :key="list.id" :value="list.name" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.inventory_province" multiple collapse-tags placeholder="省份" filterable @visible-change="getSelectWarehouseList('inventory_province')">
                <el-option v-for="list in selectMapC.inventory_province" :key="list.id" :value="list.name" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.inventory_city" multiple collapse-tags placeholder="城市" @visible-change="getSelectWarehouseList('inventory_city')">
                <el-option v-for="list in selectMapC.inventory_city" :key="list.id" :value="list.name" :label="list.name"></el-option>
            </el-select>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
            </div>
        </div>
        <div class="tableBox selectStockTable">
            <tabletem :isSetCol="true" scene="cloud.inventory.spots" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="btnList clearfix">
            <div class="totalBox">
                <div class="total">选中件数：{{totalNumber}}件</div>
                <div class="total">选中方数：{{totalCube}}</div>
            </div>
            <div class="btnBox">
                <el-button  class="funcPublicBtn" @click="cancel">取消</el-button>
                <el-button  class="funcPublicBtn" @click="selectData">选中</el-button>
                <el-button  class="funcPublicBtn funcPublicBtnChecked" @click="selectAndOut">选中并退出</el-button>
            </div>
        </div>
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="cloud.inventory.spots" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import tabletem from '../table.vue'
    import pagination from '../pagination.vue'
    export default {
        props:["supplierName","dialog"],
        data(){
            return{
                tableLoading:false,
                isShowMore:false,
                dialogVisibleWidth:false,
                module: localStorage.dw_erp_power_code,
                params:{
                    supplier_id:"",
                    supplier:this.supplierName,
                    breed:"",
                    brand:"",
                    grade:"",
                    sales_length:"",
                    sales_thickness:"",
                    sales_width_total:"",
                    inventory_province:"",
                    inventory_city:"",
                    warehouse:"",
                    bale_no:"",
                    per_page:50,
                    page:1
                },
                last_page:1,
                total:0,
                totalNumber:0,
                totalCube:0,
                selectRow:[],
                selectMapC:{
                    supplier_id:[],
                    breed:[],
                    brand:[],
                    grade:[],
                    warehouse:[],
                    sales_length:[],
                    sales_thickness:[],
                    attribute_id:[],
                    inventory_province:[],
                    inventory_city:[],
                    color_id:[],
                    opening_company_id:[]
                },
                widthList:[],
                list:[],
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[	
                    {colName:"资源状态",colKey:"bale_status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"供单号",colKey:"original_bale",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"属性",colKey:"attribute",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"选色",colKey:"color",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"cloud_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度",colKey:"cloud_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"总宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售状态",colKey:"status_text",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货主单位",colKey:"company_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"区域",colKey:"inventory_city",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"锁定人",colKey:"locker_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"锁定等级",colKey:"lock_level",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,islockLevel:true},
                    // {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // // {colName:"目的港",colKey:"purpose_port",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"入库时间",colKey:"inbound_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"库龄",colKey:"storage_age",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"库位",colKey:"storage_location",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ]
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            filterConfirm(){
                this.getList()
            },
            getSelectWarehouseList(target){
                this.$getSelectCloudSeeList(target,this.params).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            cancel(){
                this.$emit("cancel")
            },
            selectData(){
                this.$emit("selectData",this.selectRow)
            },
            selectAndOut(){
                this.$emit("selectAndOut",this.selectRow)
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                if(this.module.indexOf(',cloud-inventory-spots,')!=-1){
                    this.$postColumnList("/erp/cloud.inventory.spots",this.params,res=>{
                        this.last_page=parseInt(res.data.data.list.last_page);
                        // this.params.page=parseInt(res.data.data.data.current_page);
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                        this.total=parseInt(res.data.data.list.total);
                        this.list=res.data.data.list.data;
                        
                        this.list.forEach((item,ind)=>{
                            if(item.inbound_time){
                                this.list[ind].inbound_time = this.formatTime(this.list[ind].inbound_time+"000")
                            }else{
                                this.list[ind].inbound_time = "";
                            }
                            if((item.status==1||item.status==0)&&item.lock_status==0){
                                item.isCanSelection=false;
                            }else{
                                item.isCanSelection=true;
                            }
                        })
                        this.filter = res.data.data.column;
                        this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                        this.tableCol.forEach(item=>{
                            if(this.fields.indexOf(","+item.colKey+",")!=-1){
                                item.isShow=true;
                            }else{
                                item.isShow=false;
                            }
                        })
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="sales_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.sales_width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
            },
            getRow(row){
                this.selectRow=row;
                this.totalNumber=this.selectRow.length;
                this.totalCube=0;
                this.selectRow.forEach(item=>{
                    this.totalCube+=Number(item.sales_cube);
                })
                this.totalCube=this.keepLimit(this.totalCube)
            },
            resetSelect(){
                this.reset()
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "supplierName":function(val){
                this.params.supplier = val;
            },
            "dialog":function(val){
                if(val&&this.module.indexOf(',cloud-inventory-spots,')!=-1){
                    this.getList()
                }
            }
        }
    }
</script>
<style scoped>
    .pageAssembly .pageSize{margin-top:3px;}
    .totalBox{float: left;}
    .totalBox .total{float: left;font-size: 12px;line-height: 33px;margin-right:15px;}
    .btnBox{float: right;}
</style>